import * as React from 'react';
import { ButtonBase } from '../../..';
import { FixMeLater } from '../../../../utils';

export interface DigitalClockOptionProps {
    /**
     * The text which will be displayed.
     */
    text: string;

    /**
     * An aria-label for the option.
     */
    'aria-label': string;

    /**
     * If `true` the option is selected.
     * @default: false
     */
    selected?: boolean;

    /**
     * A callback fired when the button is clicked.
     */
    onClick?: (event: React.SyntheticEvent) => void;

    /**
     * The tabIndex of the button.
     */
    tabIndex?: number;
}

export const DigitalClockOption: React.ForwardRefExoticComponent<
    DigitalClockOptionProps & React.RefAttributes<HTMLElement>
> = React.forwardRef(function DigitalClock(
    props: DigitalClockOptionProps,
    ref: React.ForwardedRef<FixMeLater>
): React.JSX.Element {
    const { text, selected = false, 'aria-label': label, onClick, tabIndex } = props;

    return (
        <li ref={ref}>
            <ButtonBase role="option" tabIndex={tabIndex} aria-selected={selected} aria-label={label} onClick={onClick}>
                {text}
            </ButtonBase>
        </li>
    );
});
